module.exports = __webpack_public_path__ + "static/media/PDF_55.d01f4fc8.pdf";